import Vue from "vue";
import Router from "vue-router";
import OpenServices from "./views/OpenServices.vue";
import Components from "./views/Components.vue";
import NotFound from "./views/NotFound.vue";
import ComponentDetails from "./views/ComponentDetails.vue";
import Disclaimers from "./views/Disclaimers.vue";
import APICatalogue from "./views/APICatalogue.vue";
import PublishingTools from "./views/PublishingTools.vue";
import Tools from "./views/Tools.vue";
import store from "./store/store.js"; //include vuex store to access beforeRouteEnter

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: { name: "open-services" }
    },
    {
      path: "/disclaimers",
      name: "disclaimers",
      component: Disclaimers,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          { name: "Terms and conditions", nameFr: "Avis" }
        ]
      }
    },
    {
      path: "/open-services",
      name: "open-services",
      component: OpenServices,
      meta: {
        breadcrumb: [{ name: "Open Services", nameFr: "Services ouverts" }]
      }
    },
    {
      path: "/widgets",
      name: "widgets",
      component: Components,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          {
            name: "Widget Catalogue",
            nameFr: "Catalogue de widgets"
          }
        ]
      }
    },
    {
      path: "/api-catalogue",
      name: "api-catalogue",
      component: APICatalogue,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          {
            name: "API Catalogue",
            nameFr: "Catalogue de API"
          }
        ]
      }
    },
    {
      path: "/publishing-tools",
      name: "publishing-tools",
      component: PublishingTools,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          {
            name: "Publishing Tools",
            nameFr: "Outils de publication"
          }
        ]
      }
    },
    {
      path: "/widget_details/:id",
      name: "widget-details",
      component: ComponentDetails,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          {
            name: "Widget Catalogue",
            nameFr: "Catalogue de widgets",
            link: "/widgets"
          },
          {
            name: "Widget Details",
            nameFr: "Détails du widgets"
          }
        ]
      },
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch("widget/fetchWidget", routeTo.params.id)

          .then(widget => {
            routeTo.params.widget = widget;
            console.log(widget);
            if (widget == "error") {
              next({ name: "404" }); // on error redirect to 404
            } else {
              next();
            }
          });
      }
    },
    {
      path: "/tools/:id",
      name: "tools",
      component: Tools,
      props: true,
      meta: {
        breadcrumb: [
          {
            name: "Open Services",
            nameFr: "Services ouverts",
            link: "/open-services"
          },
          {
            name: "Tools",
            nameFr: "Outils"
          }
        ]
      },
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch("widget/fetchWidget", routeTo.params.id)

          .then(widget => {
            routeTo.params.widget = widget;
            console.log(widget);
            if (widget == "error") {
              next({ name: "404" }); // on error redirect to 404
            } else {
              next();
            }
          });
      }
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "*",
      redirect: { name: "404" }
    }
  ],
  // save scroll position when navigating with back/forward buttons, otherwise return to top
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
